//
//  SDKUserProfile.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export const UserOnboardingDepartments = [
    "Design",
    "Product",
    "Engineering",
    "Brand",
    "Other",
];
export const UserOnboardingJobLevels = [
    "Executive",
    "Manager",
    "IndividualContributor",
    "Other",
];
export const UserOnboardingCompanySizes = [
    "Just me",
    "2 - 49",
    "50 - 249",
    "250 - 999",
    "1,000 - 4,999",
    "5,000 - 9,999",
    "More than 10,000",
];
export const UserOnboardingDesignSystemTeamSizes = [
    "We don’t have a design system team",
    "Only one person",
    "2 - 5",
    "6 - 10",
    "More than 10",
];
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- -- - --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class UserProfile {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        this.name = (_a = model.name) !== null && _a !== void 0 ? _a : "";
        this.nickname = (_b = model.nickname) !== null && _b !== void 0 ? _b : null;
        this.avatar = (_c = model.avatar) !== null && _c !== void 0 ? _c : null;
        this.onboarding = model.onboarding
            ? {
                companyName: (_d = model.onboarding.companyName) !== null && _d !== void 0 ? _d : null,
                numberOfPeopleInOrg: (_e = model.onboarding.numberOfPeopleInOrg) !== null && _e !== void 0 ? _e : null,
                numberOfPeopleInDesignTeam: (_f = model.onboarding.numberOfPeopleInDesignTeam) !== null && _f !== void 0 ? _f : null,
                department: (_g = model.onboarding.department) !== null && _g !== void 0 ? _g : null,
                jobTitle: (_h = model.onboarding.jobTitle) !== null && _h !== void 0 ? _h : null,
                phase: (_j = model.onboarding.phase) !== null && _j !== void 0 ? _j : null,
                jobLevel: (_k = model.onboarding.jobLevel) !== null && _k !== void 0 ? _k : null,
                designSystemName: (_l = model.onboarding.designSystemName) !== null && _l !== void 0 ? _l : null,
                figmaUrl: (_m = model.onboarding.figmaUrl) !== null && _m !== void 0 ? _m : null,
                defaultDestination: (_o = model.onboarding.defaultDestination) !== null && _o !== void 0 ? _o : null,
                isPageDraftOnboardingFinished: (_p = model.onboarding.isPageDraftOnboardingFinished) !== null && _p !== void 0 ? _p : null,
                isApprovalsOnboardingFinished: (_q = model.onboarding.isApprovalsOnboardingFinished) !== null && _q !== void 0 ? _q : null,
            }
            : null;
        this.isOnboardingFinished = ((_r = model.onboarding) === null || _r === void 0 ? void 0 : _r.phase) === "finished";
        if (((_s = model.theme) === null || _s === void 0 ? void 0 : _s.preset) === "Custom") {
            this.theme = {
                preset: "Custom",
                ...model.theme,
            };
        }
        else if ((_t = model.theme) === null || _t === void 0 ? void 0 : _t.preset) {
            this.theme = {
                preset: model.theme.preset,
                isEditorWhite: model.theme.isEditorWhite,
            };
        }
        else {
            this.theme = null;
        }
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs directly manipulable update object for user profile */
    toProfileUpdateObject() {
        var _a, _b;
        return {
            name: (_a = this.name) !== null && _a !== void 0 ? _a : undefined,
            nickname: (_b = this.nickname) !== null && _b !== void 0 ? _b : undefined,
        };
    }
    toOnboardingUpdateObject() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const { onboarding } = this;
        return {
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            companyName: (_a = onboarding.companyName) !== null && _a !== void 0 ? _a : undefined,
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            numberOfPeopleInOrg: (_b = onboarding.numberOfPeopleInOrg) !== null && _b !== void 0 ? _b : undefined,
            numberOfPeopleInDesignTeam: 
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            (_c = onboarding.numberOfPeopleInDesignTeam) !== null && _c !== void 0 ? _c : undefined,
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            department: (_d = onboarding.department) !== null && _d !== void 0 ? _d : undefined,
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            jobTitle: (_e = onboarding.jobTitle) !== null && _e !== void 0 ? _e : undefined,
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            phase: (_f = onboarding.phase) !== null && _f !== void 0 ? _f : undefined,
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            jobLevel: (_g = onboarding.jobLevel) !== null && _g !== void 0 ? _g : undefined,
            designSystemName: (_h = onboarding === null || onboarding === void 0 ? void 0 : onboarding.designSystemName) !== null && _h !== void 0 ? _h : undefined,
            figmaUrl: (_j = onboarding === null || onboarding === void 0 ? void 0 : onboarding.figmaUrl) !== null && _j !== void 0 ? _j : undefined,
            defaultDestination: (_k = onboarding === null || onboarding === void 0 ? void 0 : onboarding.defaultDestination) !== null && _k !== void 0 ? _k : undefined,
        };
    }
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        var _a;
        return {
            name: this.name,
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            nickname: this.nickname,
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            avatar: this.avatar,
            onboarding: {
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                companyName: this.onboarding.companyName,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                numberOfPeopleInOrg: this.onboarding.numberOfPeopleInOrg,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                numberOfPeopleInDesignTeam: 
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                this.onboarding.numberOfPeopleInDesignTeam,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                department: this.onboarding.department,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                jobTitle: this.onboarding.jobTitle,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                phase: this.onboarding.phase,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                jobLevel: this.onboarding.jobLevel,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                designSystemName: this.onboarding.designSystemName,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                figmaUrl: this.onboarding.figmaUrl,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                defaultDestination: this.onboarding.defaultDestination,
            },
            theme: (_a = this.theme) !== null && _a !== void 0 ? _a : undefined,
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using `fromTransport` */
    toTransport() {
        return this.toRemote();
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        return new UserProfile(model);
    }
}
